<template>
  <ErrorPage 
    code="401"
    title="errors.401_title"
    message="errors.401_message"
  />
</template>

<script>
import ErrorPage from "@/layouts/ErrorPage.vue"

export default {
  name: "Error401",
  components: { ErrorPage }
}
</script>
